import { Component } from '@angular/core';
import { ModalID } from 'src/app/shared/models/constants';
// Services
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-questionnaire-into',
    templateUrl: './questionnaire-into.component.html',
    styleUrls: ['./questionnaire-into.component.scss'],
    standalone: true,
    imports: []
})
export class QuestionnaireIntoComponent {
  showAllInstructions = true;

  constructor(
    private sharedService: SharedService
  ) {
  }


  closeModalClick() {
  this.sharedService.closeModal(ModalID.questionnaire_intro);
  this.sharedService.openScanIdModal();
  }
  openAllInstructions() {
    this.showAllInstructions = !this.showAllInstructions
  }

}

